import i18next from 'i18next'
import React from 'react'
import { any, async, fromJSX, Updater, Widget } from 'widgets-for-react'
import { ActualitySearchLayout } from './actualitySearchLayout'
import { actualitySearchPageStateUpdaters, ActualitySearchResult, ActualitySearchState } from './actualitySearchState'

export const actualitySearchWidget = (
  state: ActualitySearchState
): Widget<Updater<ActualitySearchState>> =>
  any([
    async<ActualitySearchResult>(state.result).map(
      actualitySearchPageStateUpdaters.updateSearchResult
    ),
    fromJSX(() => (
      <ActualitySearchLayout {...state} />
    ))
  ])